import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import PerformanceBadge from '../Operations/PerformanceBadge';
import { customDateStr } from '../../shared/misc/utils';
import TaskStatus from '../Operations/Operation/TaskStatus';
import EsrrBadge from '../Operations/EsrrBadge';

interface Props {
  isExecution: boolean;
  title: string;
  operationNumber: string;
  stage: string;
  startDate: string;
  dueDate: string | null;
  safeguardPerformance: string;
  statusText: string;
  esrr: string;
}

const TaskDetail: React.FC<Props> = (props) => {
  const {
    isExecution,
    title,
    operationNumber,
    stage,
    startDate,
    dueDate,
    safeguardPerformance,
    statusText,
    esrr,
  } = props;
  const { t } = useTranslation();
  return (
    <div className="task-detail-container">
      <div className="task-detail-title">{title}</div>
      <div className="task-detail-op">
        <Link to={`/operations/${operationNumber}?from=/`}>{operationNumber}</Link>
      </div>
      <div>
        <span className="label">{t('stage')}:</span>
        <b>{stage}</b>
      </div>
      <div>
        <span className="label">{t('startDate')}:</span>
        <b>{customDateStr(startDate)}</b>
      </div>
      <div>
        <span className="label">{t('dueDate')}:</span>
        <b>{dueDate ? customDateStr(dueDate) : 'N/A'}</b>
      </div>
      <div className="mt-3">
        {isExecution ? (
          <>
            <span className="label">{t('safeguardPerformance')}:</span>
            {safeguardPerformance ? (
              <PerformanceBadge code={safeguardPerformance} />
            ) : (
              <b>{t('notSet')}</b>
            )}
          </>
        ) : (
          <>
            <span className="label">ESRR:</span>
            {esrr ? <EsrrBadge text={esrr} /> : <b>{t('notSet')}</b>}
          </>
        )}
      </div>
      <div className="mt-3">
        <span className="label">{t('status')}:</span>
        <TaskStatus status={statusText} text={t(`taskStatus.${statusText}`)} />
      </div>
    </div>
  );
};

export default TaskDetail;
